<template>
  <AppButton
    variant="ghost"
    :tone="tone"
    size="sm"
    block
    justify="start"
    :disabled="disabled"
    :class="['app-menu-item', itemClass]"
    v-bind="$attrs"
    @click="handleClick"
  >
    <slot />
  </AppButton>
</template>

<script>
  import AppButton from '@/components/ui/buttons/AppButton.vue';

  export default {
    name: 'AppMenuItem',
    components: {
      AppButton,
    },
    inheritAttrs: false,
    props: {
      tone: {
        type: String,
        default: 'neutral',
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      itemClass: {
        type: [String, Array, Object],
        default: '',
      },
    },
    emits: ['click'],
    methods: {
      handleClick(event) {
        if (!this.disabled) {
          this.$emit('click', event);
        }
      },
    },
  };
</script>
